import * as Colors from "../../../../globalStyles/environmentColors";

export const body = {
    padding: "30px"
};

export const podcastBtn = {
    textAlign: "right"
};

export const podcastsHeaderSection = {
    paddingTop: "30px"
};

export const podcastsSection = {};

export const cardStyles = {
    backgroundColor: Colors.primary,
    color: "white",
    cursor: "pointer"
};

export const headerCardStyles = {
    backgroundColor: Colors.primary,
    color: "white"
};

export const fileNameSlot = {
    minWidth: "80px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
};
